import { Entity } from "./entity";
import { Priority, TaskStatus, TaskType } from "./enum-type";
import { Subtask } from "./subtask";

export interface Task extends Entity {
    taskType: TaskType
    taskStatus: TaskStatus
    subject: string
    observation: string
    numeroDeContrat: string
    toBeDone: boolean
    laverieId: string
    taskListId?: string
    taskListCodeTournee?: string
    priority?: Priority
    rank?: number
    number?: string
    street?: string
    city?: string
	latitude?: number
	longitude?: number
    postcode?: string
    clientSignature?: string
    startDateTime?: Date
    endDateTime?: Date
    subtasks: Subtask[]
    productIds?: string[]
}

export class TaskExport {
    tsks: FlattenedTask[];
}

export class FlattenedTask {
    subj: string
    lav: string
    type: string
    status: string
}

export function instanceOfTask(object: any): object is Task {
    return 'taskStatus' in object;
}

export function getTaskExport(tasks: Task[]): TaskExport {
    const taskExport = new TaskExport();
    const flatTasks : Array<FlattenedTask> = [];
    tasks.forEach(t => {
        const ft = new FlattenedTask();
        ft.subj = t.subject;
        ft.lav = t.name;
        ft.type = t.taskType;
        ft.status = t.taskStatus;
        flatTasks.push(ft);
    });
    taskExport.tsks = flatTasks;
    return taskExport;
}